import { BaseLayout } from "./BaseLayout";
import layouts from "./layouts.module.css";

export const ProductLayout = ({ children, productInfo }) => {
  return (
    <BaseLayout
      seo={{
        title: productInfo.title,
        description: productInfo.description,
      }}
      header={{
        type: "full",
        overlay: true,
      }}
      footer
    >
      <main className={layouts.product}>{children}</main>
    </BaseLayout>
  );
};
